import React from 'react'
import StyledPatternBg from './Styled'

const PatternBg = ({ children }) => {
  return <StyledPatternBg>{children}</StyledPatternBg>
}
export default PatternBg
